import { render } from "./ks-heading-bio.vue?vue&type=template&id=b921fbd6"
import script from "./ks-heading-bio.vue?vue&type=script&lang=js"
export * from "./ks-heading-bio.vue?vue&type=script&lang=js"

import "./ks-heading-bio.vue?vue&type=style&index=0&id=b921fbd6&lang=css"
script.render = render

export default script